import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <CardsSection />
        <MediaSection />
        <ContactSection />
        <FaqSection />
        <TopicsSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}